import { SalutationType } from "@repo/server-api";

import type { Contact } from "@repo/server-api";

export const emptyContact: Contact = {
	id: "",
	companyName: "",
	contactNumber: "",
	contactTypes: [],
	firstName: "",
	lastName: "",
	additionalInformation: [],
	displayContactType: [],
	displayName: "",
	isACompany: false,
	isAFreelancer: false,
	isAPerson: false,
	isDeleted: false,
	isTemporary: false,
	isContactPerson: false,
	isEmployee: false,
	isAMailbox: false,
	isMemberOf: [],
	version: 0,
	salutation: SalutationType.Mr,
	shortCode: "",
	title: "",
	__typename: "Contact",
};

export const setContactValues = (contact: Contact | null): Contact => {
	return {
		...emptyContact,
		...contact,
	};
};
